import React, { useMemo } from 'react';
import Animated from 'react-native-reanimated';
import { AppView, SCREEN_BOTTOM_PADDING, withAnimatedNavigationHeader, } from 'design-system';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import { useAppSelector } from 'store/hooks';
import { ACCOUNT_SECTION_ORDER, accountListKeyExtractor, buildAccountListEntries, CreditReportAccountsEmpty, renderAccountListItem, } from '../components/CreditReportAccountSectionsList';
import CreditReportFooter from '../components/CreditReportFooter';
import { selectCreditReportClosedAccounts } from '../selectors';
import { isWeb } from '../../../constants';
const strings = {
    headerTitle: 'Closed accounts',
};
const ListEmpty = () => <CreditReportAccountsEmpty isClosed/>;
const CreditReportClosedAccountsScreen = withAnimatedNavigationHeader(({ scrollHandler }) => {
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', SCREEN_BOTTOM_PADDING, paddingHorizontalStyle);
    const creditReportClosedAccounts = useAppSelector(selectCreditReportClosedAccounts);
    const entries = useMemo(() => buildAccountListEntries(ACCOUNT_SECTION_ORDER.map((key) => ({
        key,
        accounts: creditReportClosedAccounts[key],
    }))), [creditReportClosedAccounts]);
    const hasAccounts = entries.length > 0;
    return (<AppView withFrame={false}>
          <Animated.FlatList data={entries} keyExtractor={accountListKeyExtractor} renderItem={renderAccountListItem} onScroll={scrollHandler} scrollEventThrottle={16} showsVerticalScrollIndicator contentContainerStyle={contentContainerStyle} ListEmptyComponent={ListEmpty} ListFooterComponent={hasAccounts ? CreditReportFooter : null}/>
        </AppView>);
}, ({ colors }) => ({
    title: strings.headerTitle,
    headerColorOutputRange: [
        colors.background.dark,
        colors.cards.onDark,
    ],
}));
export default CreditReportClosedAccountsScreen;
